<template>
  <div class="tab-content">
    <el-form ref="form" label-position="top" size="small">
      <el-row :gutter="15">
        <el-col :span="20">
          <el-form-item label="Name">
            <el-input v-model="general.name"></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="10">
          <el-form-item label="Status">
            <el-select class="content" size="small" v-model="general.is_published" style="width: 100%;">
              <el-option key="1" label="Active" :value="1"></el-option>
              <el-option key="2" label="Pending" :value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
      </el-row>
      <el-row :gutter="15">
        <el-col :span="20">
          <el-form-item label="Launch Code">
            <el-input v-model="general.launch_code"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-top: 30px;">
        <el-form-item>
          <el-button class="el-btn-blue" @click="updateInstance" :loading="flagLoading.save">SAVE CHANGES</el-button>
          <el-button @click="returnBack">CANCEL</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { reactive } from 'vue'
export default {
  name: 'TabGeneral',
  props: {
    role: String,
    actionItem: Object
  },
  emits: [],
  components: {
  },
  data () {
    const flagLoading = reactive({
      save: false
    })
    const flagVisible = reactive({
    })
    const actionItems = reactive({
    })
    return {
      instance: {},
      general: {},
      flagLoading,
      flagVisible,
      actionItems
    }
  },
  created: function () {
  },
  mounted () {
  },
  computed: {
  },
  watch: {
    actionItem: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          if (val) this.instance = { ...val }
          if (val && val.general) {
            this.general = { ...val.general }
            this.general.launch_code = `document.querySelector('atk-mobile').params = { instance: '${this.instance._id}', status: 'show' }`
          }
        }
      },
      deep: true
    }
  },
  methods: {
    updateInstance: function () {
      this.flagLoading.save = true
      const url = `/api/v1/atk/mobile/instances/${this.instance._id}`
      const that = this
      const body = { general: this.general }
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Update success' })
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('updateInstance', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.save = false
      })
    },
    returnBack: function () {
      this.$router.go(-1)
    }
  }
}
</script>
